// extracted by mini-css-extract-plugin
module.exports = {"cls1":"BlankSlate-BlankSlateImg-module--cls1--25oDE","cls2":"BlankSlate-BlankSlateImg-module--cls2--33sEs BlankSlate-BlankSlateImg-module--cls1--25oDE mb-4"};